import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form, Button } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import { IoMdCalendar, IoMdDoneAll, IoMdDownload } from 'react-icons/io'
import moment from 'moment'

// Local imports
import ReactTable from '../../../components/FilterTable'
import Loader from '../../../components/Loader'
import { fetchInventory } from '../../../actions/reports/inventoryActions'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from '../../../components/Footer'
const InventoryPage = ({ dispatch, loading, hasErrors, inventory }) => {

    const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0))
    const fileName = 'Inventory';

    let filterStartDate = moment(startDate).format("L")
    let filterEndDate = moment(endDate).format("L")
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [greaterErr, setGreaterErr] = useState(false)
    const [emptyErr, setEmptyErr] = useState(false)

    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        } else {
            e.preventDefault()

            if (startDate > endDate) {
                setGreaterErr(true)
                return false
            } else if (startDate < endDate) {
                setGreaterErr(false)
            } else {
                setGreaterErr(false)
            }

            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = startDate
            filterEndDate = endDate

            dispatch(fetchInventory(filterStartDate, filterEndDate, setValidated))
            setBtnDisable(true)
        }
        setValidated(true)
    }

    useEffect(() => {
        dispatch(fetchInventory(filterStartDate, filterEndDate, setValidated))
        setValidated(false)
    }, [dispatch])

    const columns = [{
        Header: 'SKU',
        accessor: 'SKU',
        filter: 'SKU',
        sortType: 'basic'
    }, {
        Header: 'NDC',
        accessor: 'NDC',
        filter: 'NDC',
        sortType: 'basic'
    }, {
        Header: 'Product Name',
        accessor: 'ProductName',
        filter: 'Product',
        sortType: 'basic',
        width: 200
    }, {
        Header: 'Quantity',
        accessor: 'Quantity',
        filter: 'Quantity',
        sortType: 'basic',
        width: 100

    }, {
        Header: 'Available Quantity',
        accessor: 'AvailableQuantity',
        filter: 'AvailableQuantity',
        sortType: 'basic'
    },
    {
        Header: 'Cost',
        accessor: 'Cost',
        filter: 'Cost',
        sortType: 'basic',
        width: 100
    },
    {
        Header: 'Net Cost',
        accessor: 'NetCost',
        filter: 'NetCost',
        sortType: 'basic',
        width: 100
    },
    {
        Header: 'Manufacturer Name',
        accessor: 'ManufacturerName',
        filter: 'ManufacturerID',
        sortType: 'basic'
    },
    {
        Header: 'Lot Number',
        accessor: 'LotNumber',
        filter: 'LotNumber',
        sortType: 'basic',
        width: 120
    },
    {
        Header: 'Created Date',
        accessor: 'CreatedOn',
        filter: 'CreatedOn',
        sortType: 'basic',
        width: 110,
        filterMethod: (filter, row) => {
            const rowValue = row.original
            return rowValue.datefiled.includes(filter.value)
        }
    }, {
        Header: 'Expired Date',
        accessor: 'ExpirationDate',
        filter: 'ExpirationDate',
        sortType: 'basic',
        width: 110,
        filterMethod: (filter, row) => {
            const rowValue = row.original
            return rowValue.datefiled.includes(filter.value)
        }
    }, {
        Header: 'Inventory Transaction Date',
        accessor: 'InventoryTransactionDate',
        filter: 'InventoryTransactionDate',
        sortType: 'basic',
        filterMethod: (filter, row) => {
            const rowValue = row.original
            return rowValue.datefiled.includes(filter.value)
        }
    },
    {
        Header: 'Status',
        accessor: 'Status',
        filter: 'Status',
        sortType: 'basic',
        width: 80
    },
    ]


    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Inventory Transaction</h2>
                {inventory.length > 0 ? <Button type="submit" onClick={() => getExcel(columns, inventory, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
            </div>

            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <Form noValidate validated={validated} onSubmit={submitHandler}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="StartDate">
                                                    Since
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setGreaterErr(false)
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className={greaterErr ? "form-control is-invalid" : "form-control"}
                                                />
                                                {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                                                {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="EndDate">
                                                    Until
                        </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setEndDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className="form-control"
                                                />
                                                <Form.Control.Feedback type="invalid">Please select End Date.</Form.Control.Feedback>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mt-2">
                                            <Button type="submit" className="mt-3" disabled={btnDisable}>
                                                <IoMdDoneAll className="icon btn-icon" />
                        Submit
                      </Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>

                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                                {loading ? <Loader /> : hasErrors ? <p>Error occurred. Unable to load inventory.</p> :
                                    <div className="inventory-grid">
                                        <Fragment>
                                            {inventory.length > 0 ?
                                                <ReactTable columns={columns} data={inventory} defaultPageSize={10} />
                                                :
                                                <div className="no-data">No data found.</div>
                                            }
                                        </Fragment>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Footer />
        </section>
    )
}

// Map Redux state to React component props
const mapStateToProps = state => ({
    loading: state.inventory.loading,
    inventory: state.inventory.inventory,
    hasErrors: state.inventory.hasErrors,
})

// Connect Redux to React
export default connect(mapStateToProps)(InventoryPage)